import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client'
import B2C_GET_OPEN_ORDERS from '@graphql/queries/getOpenOrders.query'
import { B2CGetOpenOrdersQuery, B2CGetOpenOrdersQueryVariables } from 'parkdepot-shared/gql/graphql'

const useLazyGetOpenOrders = (opts: LazyQueryHookOptions<B2CGetOpenOrdersQuery, B2CGetOpenOrdersQueryVariables>) => {
    return useLazyQuery(B2C_GET_OPEN_ORDERS, opts)
}

export default useLazyGetOpenOrders
